const navigationConfig = [];
export default navigationConfig;

/**

    {
        'id': 'applications',
        'title': 'Portail Origin',
        'type': 'group',
        'icon': 'apps',
        'children': []
    },

{
    'id': 'dashboard-component',
    'title': 'Tableau de bord',
    'type': 'item',
    'icon': 'dashboard',
    'url': '/dashboard'
}, {
    'id': 'sinister-expert-page',
    'title': 'Expert Sinistre',
    'type': 'item',
    'auth': 'login',
    'icon': 'donut_large',
    'url': '/sinister-expert'
}, {
    'id': 'news-page',
    'title': 'Bloc de nouvelles',
    'type': 'item',
    'auth': 'login',
    'icon': 'bookmarks',
    'url': '/news-block'
}, {
    'id': 'kpis-page',
    'title': 'Indicateurs de performance',
    'type': 'item',
    'auth': 'login',
    'icon': 'multiline_chart',
    'url': '/kpis'
}, {
    'id': 'clients-page',
    'title': 'Clients',
    'type': 'item',
    'auth': 'login',
    'icon': 'group',
    'url': '/clients'
}, {
    'id': 'documentation-page',
    'title': 'Gestion documentaire',
    'type': 'item',
    'auth': 'login',
    'icon': 'description',
    'url': '/documentation'
}, {
    'id': 'health-security-page',
    'title': 'Santé et sécurité au travail',
    'type': 'item',
    'auth': 'login',
    'icon': 'enhanced_encryption',
    'url': '/health-security'
}, {
    'id': 'tools-page',
    'title': 'Outils',
    'type': 'item',
    'auth': 'login',
    'icon': 'build',
    'url': '/tools'
}, {
    'id': 'support-ti-page',
    'title': 'Support TI',
    'type': 'item',
    'auth': 'login',
    'icon': 'contact_support',
    'url': '/support-ti'
}, {
    'id': 'gt-management-page',
    'title': 'Gestion GT',
    'type': 'item',
    'auth': 'login',
    'icon': 'computer',
    'url': '/gt-management'
}, {
    'id': 'ms-team-page',
    'title': 'Teams',
    'type': 'link',
    'auth': 'login',
    'icon': 'question_answer',
    'url': 'https://teams.microsoft.com'
},

 */
